import React from 'react';
import { Outlet, Search, Bell } from 'react-router-dom';
import { Search as SearchIcon, Bell as BellIcon } from 'lucide-react';

/**
 * GlobalAdminLayout
 * A clean, full-width layout with a top header and content area.
 * Sidebar has been entirely removed.
 */
const GlobalAdminLayout = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col font-roboto text-[#374151]">
      {/* Top Header */}
      <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-8 sticky top-0 z-30">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold shadow-sm">
            G
          </div>
          <span className="font-poppins font-bold text-xl tracking-tight text-gray-900">
            HRMS<span className="text-indigo-600">.</span>
          </span>
        </div>

        <div className="flex items-center gap-6">
          <div className="relative w-64 hidden md:block">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
            <input 
              type="text" 
              placeholder="Search..." 
              className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-transparent focus:bg-white focus:border-indigo-100 rounded-lg text-sm transition-all outline-none"
            />
          </div>
          
          <button className="p-2 text-gray-400 hover:bg-gray-50 rounded-full relative transition-colors">
            <BellIcon size={20} />
            <span className="absolute top-2 right-2 w-2 h-2 bg-rose-500 rounded-full border-2 border-white" />
          </button>

          <div className="h-8 w-px bg-gray-200" />

          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <p className="text-xs font-bold text-gray-800 leading-tight">Alex Stanford</p>
              <p className="text-[10px] text-gray-400 uppercase font-bold tracking-tighter">Global Admin</p>
            </div>
            <div className="w-9 h-9 rounded-full bg-indigo-100 border-2 border-white shadow-sm flex items-center justify-center text-indigo-600 font-bold text-xs">
              AS
            </div>
          </div>
        </div>
      </header>

      {/* Main Content Wrapper */}
      <main className="flex-1 w-full">
        <Outlet />
      </main>
    </div>
  );
};

export default GlobalAdminLayout;